module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/instagram-1776b1990592dafc3db765e3ee2e26f1.svg&quot;;"